// @ts-nocheck
import React, { useState, Fragment } from "react"

import { Flex, Grid } from "../../container-components"
import Popover from "@mui/material/Popover";
import { IconButton } from "../../element-components"
import { Typography } from "../../typo-components"

export default function ConfirmationButton({ color, confirmationConfig, ButtonComponent }) {
	const { onConfirm, text, onInitialClick } = confirmationConfig
	const [anchorEl, setAnchorEl] = useState(() => null)
	const handleClose = () => setAnchorEl(null)

	return (
		<Fragment>
			<ButtonComponent
				color={color}
				onClick={async (event) => {
					event.persist()
					event.stopPropagation()
					event.preventDefault()

					const currentTarget = event.currentTarget

					if (onInitialClick) await onInitialClick()
					setAnchorEl(currentTarget)
				}}
			/>

			<Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose} disableRestoreFocus>
				<Flex>
					<Grid style={{ gridTemplateColumns: "auto auto", padding: "20px 30px" }} layout={[]}>
						<Flex nowrap yAlign="flex-start">
							<Typography style={{ whiteSpace: "break-spaces" }} color={color} textAlign="left" variant="t6">
								{text}
							</Typography>

							<div style={{ width: "15px" }} />
						</Flex>

						<IconButton
							margin="0 -10px 0 0"
							color={color}
							style={{ justifySelf: "flex-end" }}
							iconConfig={{
								size: "small",
								name: "check"
							}}
							onClick={async () => {
								handleClose()
								await onConfirm()
							}}
						/>
					</Grid>
				</Flex>
			</Popover>
		</Fragment>
	)
}
